import React, { Fragment,useEffect,useState } from "react";
import ReactGA from "react-ga4";
import InsightsCard from "../components/InsightsCard";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { appService } from "../App/app.service";
import { Grid } from "@material-ui/core";
import NavItemMenuComponentNew from "../components/NavItemMenuComponentNew";
import SettingsRoutes from "./SettingsRoutes";
import PlatformInfo from "./PlatformInfo/PlatformInfo";
import { useHistory } from "react-router-dom";

const styles = (theme) => ({});

const Settings = (props) => {
  const history = useHistory();
  const [charts, setCharts] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [confirmSignal, setConfirmSignal] = React.useState(false);
  const [selectedDashboard, setSelectedDashboard] = React.useState({});

  useEffect(() => {
    // Add default thumbnail and description if missing
    const chartsWithDefaults = props.charts.map(chart => ({
      ...chart,
      URL_for_Thumbnail: chart.URL_for_Thumbnail || getDefaultThumbnail(chart.Chart_Name),
      Description: chart.Description || getDefaultDescription(chart.Chart_Name)
    }));
    setCharts(chartsWithDefaults);
  }, [props.charts]);

  const getDefaultThumbnail = (chartName) => {
    const thumbnails = {
      "Change Password": "Change_Password.PNG",
      "Quota Maintenance": "Stage Progression Analysis.png",
      "User Management": "Stage Progression Analysis.png"
    };
    return thumbnails[chartName] || "Stage Progression Analysis.png";
  };

  const getDefaultDescription = (chartName) => {
    const descriptions = {
      "Change Password": "Change Password",
      "Quota Maintenance": "Maintain Rep, Team and Company quota",
      "User Management": "Provision new SkyGeni users, deactivate or reactivate existing users"
    };
    return descriptions[chartName] || "";
  };

  const cleanAfterConfirm = () => {
    setConfirmSignal(false);
    setSelectedDashboard({});
  };

  const handleOpen = ({ dashboard_id, Chart_Name }) => {
    setSelectedDashboard({ dashboard_id, Chart_Name });
    setOpen(true);
  };

  const handleConfirmClose = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setConfirmSignal(false);
    setOpen(false);
  };

  useEffect(() => {
    props.getSettings();
  }, []);

  const baseURL = "https://skygeniwebapp.blob.core.windows.net/thumbnails/";

  const handleLocationChange = (loc) => {
    props.changeSettingsPage(loc);
  };

  return (
    <>
      <NavItemMenuComponentNew
        location={props.location}
        isFavActionLoading={props.isFavActionLoading}
        routesComponent={<SettingsRoutes location={props.location} />}
        removeFavourite={props.removeFavourite}
        handleConfirmClose={handleConfirmClose}
        setConfirmSignal={setConfirmSignal}
        open={open}
        handleClose={handleClose}
        handleOpen={handleOpen}
        charts={charts}
        setCharts={setCharts}
        handleLocationChange={handleLocationChange}
        baseURL={baseURL}
        selectedDashboard={selectedDashboard}
        cleanAfterConfirm={cleanAfterConfirm}
        confirmSignal={confirmSignal}
        addFavourite={props.addFavourite}
      />
      {props.location === "home" && (
        <Grid container>
          <Grid item xs={12} container justifyContent="center">
            <PlatformInfo />
          </Grid>
        </Grid>
      )}
    </>
  );
};

function mapStateToProps(state) {
  const { persistentAlert, alert, settings, version, settingsPage, user, isFavActionLoading } =
    state.app;

  return {
    persistentAlert,
    location: settingsPage,
    alert,
    settings,
    version,
    isFavActionLoading,
    charts: user.elements
      .filter((item) => item.navItem === "Settings")[0]
      .charts.sort((a, b) => a.Sequence - b.Sequence),
  };
}

const mapDispatchToProps = (dispatch) => ({
  changePass: (oldpassword, newpassword) => {
    dispatch({ type: "change_pass_loggedin_request" });
    appService.changePassLoggedIn(oldpassword, newpassword).then(
      (json) => {
        dispatch({ type: "change_pass_loggedin_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "change_password_loggedin_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "change_password_loggedin_failure", error });
      }
    );
  },
  getSettings: () => {
    dispatch({ type: "get_settings_request" });
    appService.getSettings().then(
      (json) => {
        dispatch({ type: "get_settings_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_settings_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_settings_failure", error });
      }
    );
  },
  addFavourite: (chartID, navItem) => {
    dispatch({
      type: "add_favourite_request",
      payload: chartID,
    });
    appService.putFavourite(chartID).then(
      (json) => {
        dispatch({ type: "add_favourite_success", json: { ...json, navItem, chartID } });
      },
      (error) => {
        if (typeof error === "object") {
          console.log("add_favourite_failure", error);
          dispatch({
            type: "add_favourite_failure",
            error: "Something went wrong",
          });
        } else dispatch({ type: "add_favourite_failure", error });
      }
    );
  },
  removeFavourite: (chartID, navItem) => {
    dispatch({
      type: "delete_favourite_request",
      payload: chartID,
    });
    appService.deleteFavourite(chartID).then(
      (json) => {
        dispatch({
          type: "delete_favourite_success",
          json,
          payload: { dashboard_id: chartID, navItem },
        });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "delete_favourite_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "delete_favourite_failure", error });
      }
    );
  },
  changeSettingsPage: (loc) => {
    ReactGA.send({ hitType: "pageview", page: loc });
    dispatch({ type: "change_SettingsPage", loc });
    localStorage.setItem("skygeni-user-SettingsPage", loc);
    localStorage.removeItem("skygeni-user-repPage");
    localStorage.removeItem("skygeni-user-productPage");
  },
});

const connectedSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Settings));
export { connectedSettings as Settings };
